import { WeaTools } from 'ecCom'

export const getFormField = (params) => {
    return WeaTools.callApi('/api/hrm/systeminfo/getHrmSystemInfoForm', 'GET', params);
}

export const getWeekInfo = (params) => {
    return WeaTools.callApi('/api/hrm/systeminfo/getWeekInfo', 'GET', params);
}

export const doSave = (params) => {
    return WeaTools.callApi('/api/hrm/systeminfo/save', 'POST', params);
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/apis/systeminfo.js